import React, { useRef } from "react";

import { Box, Button, ButtonGroup, Flex } from "@chakra-ui/react";

const ExportButton = ({ handleDownload, files, fileType, setFileType }) => {
  const slideIDiv = useRef(null);
  return (
    <>
      <ButtonGroup
        isAttached
        mt="48px"
        mb="20px"
        mr="5px"
        style={{
          transition: "all 5s ease",
          position: "relatve",
        }}
      >
        <Button
          width="168px"
          height="70px"
          background="#FFEF99"
          borderL="12px"
          color="#131215"
          fontSize="20px"
          lineHeight="24px"
          onClick={handleDownload}
          _focus={{ border: "none" }}
        >
          Export
        </Button>
        <Button
          width="68px"
          height="70px"
          background="#2E2C22"
          color="#f8f8f8"
          borderBottomRight="12px"
          _hover={{ opacity: ".95" }}
          _active={{ opacity: ".9" }}
          _focus={{ border: "none" }}
          onClick={() => {
            slideIDiv.current.style.transition = "all .8s ease";
            slideIDiv.current.style.display = "block";
            
            // with Three Export Options
            // slideIDiv.current.style.transform = "translate(168px,-192px)";

            // with Two Export Options
            slideIDiv.current.style.transform = "translate(168px,-128px)";
          }}
        >
          <img src={files[fileType].img} alt="" width="34px" height="34px" />
        </Button>

        <Box
          ref={slideIDiv}
          background="#2E2C22"
          borderTopRadius="8px"
          width="68px"
          style={{
            display: "none",
            position: "absolute",
            boxShadow: "0px 0px 16px 0px rgba(0,0,0,0.2)",
            zindex: 1,
          }}
        >
          {files.map((types) => {
            return (
              <>
                <Flex py="8px">
                  <Button
                    // width="24px"
                    // height="24px"
                    background="none"
                    m="4px"
                    onClick={() => {
                      setFileType(types.id);
                      slideIDiv.current.style.display = "none";
                    }}
                    _hover={{ opacity: ".95" }}
                    _active={{ opacity: "none" }}
                    _focus={{ border: "none" }}
                  >
                    <img src={types.img} alt="" />
                  </Button>
                </Flex>
                <hr style={{ background: "white", paddingTop: "0px" }} />
              </>
            );
          })}
        </Box>
      </ButtonGroup>
    </>
  );
};

export default ExportButton;
